import moment from 'moment';
import { getIntl } from 'umi';

import { CoreEnums } from '@/utils/domain/constants';
import env from '@/config/env';
import CoreFormula from '../../formula';
import BaseFieldHandler from '../BaseFieldHandler';

const { FormFieldType, FormFieldStringType } = CoreEnums;

export default class DateTimeFieldHandler extends BaseFieldHandler {
  static supportedTypes = [
    FormFieldStringType.Time,
    FormFieldStringType.DateTime,
    FormFieldStringType.Date,
    FormFieldType.Time,
    FormFieldType.DateTime,
    FormFieldType.Date,
  ];

  handle() {
    const config = this.getBaseConfig();
    const { isDetails } = this.fieldState;
    const deeps = this.getDependencies();

    const {
      type,
      format,
      minValue,
      maxValue,
      currentDateDefaultValueEnabled,
      currentTimeDefaultValueEnabled,
      currentDateTimeDefaultValueEnabled,
    } = this.baseConfig;

    const withCurrentDate = currentDateDefaultValueEnabled || currentDateTimeDefaultValueEnabled;
    const typeConfigs = this.getTypeConfigs(type, format);

    const date =
      currentTimeDefaultValueEnabled && !config.value
        ? moment()
        : withCurrentDate && !config.value
        ? moment()
        : config.value;

    return {
      ...config,
      type: 'datepicker',
      value: date,
      ...typeConfigs.config,
      ...this.getDateValidation(minValue, maxValue),
      deeps,
    };
  }

  getTypeConfigs(type, format) {
    const toDate = {
      format: format ? CoreFormula._CleanMomentFormat(format) : 'L',
      isCurrentDateDefaultValue: this.baseConfig.currentDateDefaultValueEnabled,
      parseFormat: env.DATE_PARSE_FORMAT,
    };

    const toDateTime = {
      showTime: true,
      format: format
        ? CoreFormula._CleanMomentFormat(format)
        : getIntl().locale === 'en-US'
        ? 'MM/DD/YYYY HH:mm'
        : 'DD/MM/YYYY HH:mm',
      isCurrentDateDefaultValue: this.baseConfig.currentDateTimeDefaultValueEnabled,
      parseFormat: env.DATE_TIME_PARSE_FORMAT,
      utc: true,
    };

    const toTime = {
      type: 'timepicker',
      format: format ? CoreFormula._CleanMomentFormat(format) : 'HH:mm',
      isCurrentTimeDefaultValue: this.baseConfig.currentTimeDefaultValueEnabled,
      parseFormat: 'HH:mm',
      isTime: true,
    };

    const configs = {
      [FormFieldStringType.Date]: toDate,
      [FormFieldStringType.DateTime]: toDateTime,
      [FormFieldStringType.Time]: toTime,
      [FormFieldType.Date]: toDate,
      [FormFieldType.DateTime]: toDateTime,
      [FormFieldType.Time]: toTime,
    };

    const baseConfig = configs[type] || toDate;

    return {
      format: baseConfig.format,
      config: { ...baseConfig, parseFormat: undefined },
    };
  }

  getDateValidation(minValue, maxValue) {
    if (!minValue && !maxValue) return {};

    return {
      disabledDate: (current) => {
        const max = maxValue ? current > moment(maxValue).endOf('day') : null;
        const min = minValue ? current < moment(minValue).subtract(1, 'days').endOf('day') : null;

        if (min && max) return current && min && max;
        if (max) return current && max;
        return current && min;
      },
    };
  }
}
